// extracted by mini-css-extract-plugin
module.exports = {"root":"Wrapper_root__3Sthf","overlayDark":"Wrapper_overlayDark__3Y-Jv","overlayLight":"Wrapper_overlayLight__1TmTO","inner":"Wrapper_inner__1SHK4"};